
import './emailTemplateForm.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import zone from '../../service/zone';
import user from '../../service/user';
import menuLayout from '../../directive/menu-layout';
import emailEditor from '../../directive/email-editor';
import emailTemplate from '../../service/emailTemplate';

import routing from './emailTemplateForm.routes';
import EmailTemplateFormController from './emailTemplateForm.controller';

export default angular.module('page.emailTemplateForm', [
		uirouter,
		menuLayout,
		emailEditor,
		'uiSwitch',

		emailTemplate,
		user,
		zone
	])
	.config(routing)
	.controller('EmailTemplateFormController', EmailTemplateFormController)
	.name;



// WEBPACK FOOTER //
// ./src/page/emailTemplateForm/index.js